/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


document.onreadystatechange = () => {
  	if (document.readyState === 'complete') {
		bindCustomEvents();
		var drft;
		if(document.body.classList.contains('template-product')) {
			var loadTimer = setInterval(function() {
				if (document.querySelectorAll('.image-zoom.Image--lazyLoaded').length > 0 && window.innerWidth > 1024) {
					var zoomImgs = document.querySelectorAll('.image-zoom');
					zoomImgs.forEach((item) => {
						if(item.nextElementSibling != null){
							drft = new Drift(item, {
								paneContainer: item.nextElementSibling,
								zoomFactor: 2,
								inlineOffsetY: -85,
								containInline: true,
								hoverBoundingBox: true
							});
							//drft.disable();
							}
					});
					clearInterval(loadTimer); 
				}
			}, 200);
		}
		customModal();
		quickView();

	}	
};

function bindCustomEvents() {
	var range = document.querySelectorAll(".js-range");
	var resetBtn = document.querySelectorAll('.js-reset-filters');
	
	resetBtn.forEach((obj) =>{
		obj.addEventListener('click', function() {
			var range_trigger = document.getElementsByClassName('js-range-trigger');
	        var range_el = document.getElementsByClassName('js-range');
	        Array.prototype.filter.call(range_el, function(tElement){
	        	tElement.nextSibling.nextSibling.innerHTML = '£100';
			  return tElement.value = 100;
			});
		});
	});

	range.forEach((obj) =>{
		obj.addEventListener("change", function(event){
			event.target.nextElementSibling.nextElementSibling.click();
		});
		obj.addEventListener("input", function(event){
		  	event.target.nextElementSibling.innerHTML = '£'+event.target.value;
		  	event.target.nextElementSibling.nextElementSibling.setAttribute('data-tag','price_'+event.target.value);	
		});
	});
}

function quickView() {
	var ProductItems = document.querySelectorAll('.ProductItem__Wrapper');
	if(typeof ProductItems == 'undefined' || ProductItems.length <= 0) return false;

	if(window.innerWidth > 1024) {
		ProductItems.forEach((item) => {
			item.addEventListener("mouseover", function(){
				item.classList.add('hovered');
				item.getElementsByClassName('quick-view-button')[0]?.classList.add('show');
			});
			item.addEventListener("mouseout", function(){
				item.classList.remove('hovered');
				item.getElementsByClassName('quick-view-button')[0]?.classList.remove('show');
			});
		});
	}

	customModal();

	var quickView = document.querySelectorAll('.ProductItem__Wrapper .quick-view');
	quickView.forEach((item) => {
		item.addEventListener("click", function(){
			var product_handle = item.dataset.handle;
			var url = '/products/' + product_handle + '?quickview=true';
        	return fetch(url).then(function (response) {
				response.text().then(function (content) {
					var quickViewModalBody = document.querySelector('#quickViewModal .modal-body');
					var tempElement = document.createElement('div');
            		tempElement.innerHTML = content;	
					quickViewModalBody.innerHTML = tempElement.querySelector('#shopify-section-product-template').innerHTML;					
					openModal(quickViewModal);
					loadRatingSnip();

					//Listen to your custom event
					window.onloadQuickview(); 
					var zoomImgs = document.querySelectorAll('.image-zoom');
					zoomImgs.forEach((item) => {
						if(item.nextElementSibling != null){
							new Drift(item, {
								paneContainer: item.nextElementSibling,
								zoomFactor: 2,
								inlineOffsetY: -85,
								containInline: true,
								hoverBoundingBox: true
							});
						}
					});
				});
			});
		});
	});
}

//Modal Open events 
function openModal(modal) {
	modal.style.display = "block";
	document.documentElement.classList.add('no-scroll');
}
//Modal close events  
function customModal (){
	var modal = document.querySelectorAll('.modal');

	modal.forEach((obj) =>{
		var closeBtn = obj.getElementsByClassName('close')[0];

		// When the user clicks on <span> (x), close the Modal
		closeBtn.addEventListener('click', function() {
			obj.style.display = "none";
			document.documentElement.classList.remove('no-scroll');
		});

		// When the user clicks on outside of the Modal
		window.onclick = function(event) {
			if (event.target == obj) {
				obj.style.display = "none";
				document.documentElement.classList.remove('no-scroll');
			}
		}
	});
}

/* mouse hover cart */

if(jQuery(window).width() > 1024) {
	jQuery(".dropdown-cart").mouseenter(function(){
		jQuery("#sidebar-cart").attr("aria-hidden","false");
	});
	jQuery(".Drawer__Close").click(function(){
		jQuery("#sidebar-cart").attr("aria-hidden","true");
	});
}
 
/* Size guide */ 

jQuery(document).on('click',"#size-guide-link",function(){
	jQuery(".size-guide-model-wrapper").css("display", "block");
	jQuery("body").css("overflow", "hidden");
}); 
jQuery(document).on('click',"#close-popup",function(){
	jQuery(".size-guide-model-wrapper").css("display", "none");
	jQuery("body").css("overflow", "unset");
});  
jQuery('body').on('keyup',function(e) {
	if (e.keyCode == 27) {
	  jQuery(".size-guide-model-wrapper").css("display", "none");
	  jQuery("body").css("overflow", "unset");
	}
});


